import React from 'react';
import { STATS } from '../mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const WhyYellow = () => {
  return (
    <section className="py-24 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
          <div className="lg:col-span-6">
            <p className="section-label mb-4">Why Yellow</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[54px] font-bold text-white leading-[1.05] mb-6">
              Revolutionising how you <span className="text-[#F5CD1B]">communicate</span> with clients and staff.
            </h2>
            <p className="text-white/70 text-lg leading-relaxed mb-5">
              From strategy and planning through creative production, campaign delivery and reporting, our Liverpool-based team creates high quality work that showcases your brand at its best.
            </p>
            <p className="text-white/70 text-lg leading-relaxed mb-8">
              Our team covers the entire UK. Clients have ranged from Southampton to Aberdeen! Wherever you're based, we can help.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to="/improve-public-awareness" className="btn-yellow inline-flex items-center gap-2 px-6 py-4 rounded-md uppercase text-sm">
                Improve public awareness <ArrowRight size={16} />
              </Link>
              <Link to="/competing-on-price" className="btn-yellow inline-flex items-center gap-2 px-6 py-4 rounded-md uppercase text-sm">
                Stop competing on price <ArrowRight size={16} />
              </Link>
              <Link to="/losing-staff" className="btn-yellow inline-flex items-center gap-2 px-6 py-4 rounded-md uppercase text-sm">
                Better internal comms <ArrowRight size={16} />
              </Link>
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-4">
              {STATS.map((s, i) => (
                <div key={i} className="bg-[#111114] border border-white/10 rounded-xl p-6 lg:p-8 hover:border-[#F5CD1B]/40 transition-colors">
                  <div className={`font-display font-bold text-[#F5CD1B] leading-[1.05] ${s.value.length > 10 ? 'text-xl md:text-2xl lg:text-[26px]' : 'text-3xl md:text-4xl lg:text-5xl whitespace-nowrap'}`}>
                    {s.value}
                  </div>
                  <p className="text-white/60 text-sm mt-3">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyYellow;
